import React, { useCallback } from 'react';
import useComposerStore from '../../configurator-composer/composer/composerStore';
import { useTreeNodeManager } from '../scene-editors/hooks/useTreeNodeManager';
import ComposerAttributes from './attributes/composerAttributes';
import { ComposerAttributeNode } from './attributes/composerAttributesModels';

const AttributesEditor: React.FC = () => {
    const createNodeOverlay = useCallback((node: ComposerAttributeNode) => {
        // Per le camere, non creiamo overlay dal tree
        return () => null;
    }, []);
    const currentAttributes = useComposerStore((state) => state.attributes);
    const actionTreeState = useTreeNodeManager<ComposerAttributeNode>(currentAttributes, createNodeOverlay);
    return <ComposerAttributes state={actionTreeState} />;
};

export default AttributesEditor;
